var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#FFF",
  stroke: "#637878"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#637878"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.157 9.136.707.707-12.02 12.021-.708-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.843 9.136 12.021 12.02-.707.708L9.136 9.844z"
})))));
export default SvgXCircle;